import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./ImportantUpdates.css";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import CopyLogo from "../../../../assets/images/onboardingImages/logo_black.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { globalBusinessName } from "../../../../store/globalstore";
import { useAtom } from "jotai";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { toastify } from "../../../../helpers/toast/toastify";
import { fetchUser } from "../../../../helpers/helper";
import { useDispatch, useSelector } from "react-redux";
import { storeUser } from "../../../../redux/users/usersSlice";

const SubmitEmail = () => {
  const { state:locationState } = useLocation();
  const [show, setShow] = useState(true); // Modal visibility
  const [email, setEmail] = useState("");
  const [businessName] = useAtom(globalBusinessName);
  const { user } = useSelector((state) => state.user);

  const api = useApi();
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;
  const handleClose = () => {
    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };
  const updateUserEmail = async () => {
    if (!email) return toastify("Email is required");
    if (!/\S+@\S+\.\S+/.test(email))
      return toastify("Please enter a valid email address", "error");
    const res = await api("post", "authorizeNewonBoard/updateUserEmail", {
      email,
    });
    if (res?.status) {
      await fetchUser(api, dispatch, storeUser);
      navigate("/leader/onboarding/verify", { replace: true });
    }
  };
  useEffect(()=>{
    if(!locationState&&!(locationState?.from==="onboarding")){
      navigate("/leader/dashboard", { replace: true });
      return;
     }
  },[])
  // if(isOnBoardingComplete){
  //   navigate("/leader/dashboard", { replace: true });
  //   return;
  //  }
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-onboarding-modal"
        backdropClassName="onboarding-custom-backdrop"
      >
        <Modal.Body>
          <button type="button" className="reverseArrow">
            <img
              src={Arrow}
              alt="Arrow Image"
              onClick={() => {
                if (user?.socialLogin?.discord?.id) {
                  navigate("/leader/onboarding/importantUpdates", {
                    replace: true,
                  });
                } else {
                  navigate("/leader/onboarding/payout", {
                    replace: true,
                  });
                }
              }}
            />
          </button>
          <button type="button" className="CrossIcon" onClick={handleClose}>
            <img src={Cross} alt="Cross Image" />
          </button>
          <div className="onboardingContentBox submitEmailPage">
            <p className="businessName">{businessName}</p>
            <h2 className="title">
              <span>Submit the right email</span>
            </h2>
            <p className="desc">Please use the code sent to your email.</p>
            <div className="formBox">
              <div className="mb-20px">
                <FloatingTextFiled
                  className="onboardingInput"
                  label="Email"
                  placeholder="Email"
                  type="Text"
                  value={email}
                  onChange={(e) => {
                    setEmail(e?.target?.value);
                  }}
                />
              </div>
              <button
                type="button"
                className="NextBtn"
                onClick={updateUserEmail}
              >
                Next
              </button>
            </div>
          </div>
          <div className="copyrightBox">
            <p className="">
              Powered by{" "}
              <span className="spanMain">
                <img src={CopyLogo} alt="" />
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SubmitEmail;
